import { lazy } from 'react';

// project imports
import HomeLayout from 'layout/HomeLayout';
import Loadable from 'ui-component/Loadable';

const Channel = Loadable(lazy(() => import('views/Channel')));
const MaasVpnChannel = Loadable(lazy(() => import('views/MaasVpnChannel')));
const Log = Loadable(lazy(() => import('views/Log')));
const VideoTaskLog = Loadable(lazy(() => import('views/VideoTaskLog')));
const Redemption = Loadable(lazy(() => import('views/Redemption')));
const Setting = Loadable(lazy(() => import('views/Setting')));
const TokenNew = Loadable(lazy(() => import('views/Token_new')));
const Topup = Loadable(lazy(() => import('views/Topup')));
const User = Loadable(lazy(() => import('views/User')));
const Profile = Loadable(lazy(() => import('views/Profile')));
const ProfileNew = Loadable(lazy(() => import('views/Profile_new')));
const NotFoundView = Loadable(lazy(() => import('views/Error')));

// dashboard routing
const Dashboard = Loadable(lazy(() => import('views/Dashboard')));
const ModelSquare_new = Loadable(lazy(() => import('views/ModelSquare_new')));
const ModelSquareManage = Loadable(lazy(() => import('views/ModelSquareManage')));
const ModelTagManage = Loadable(lazy(() => import('views/ModelTagManage')));
const ModelDetailsNew = Loadable(lazy(() => import('views/ModelDetails_new')));
const ExplorationCenterChatBot = Loadable(lazy(() => import('views/ExplorationCenter/ChatBot')));
const StatisticsPanel = Loadable(lazy(() => import('views/StatisticsPanel')));
const AlarmPanel = Loadable(lazy(() => import('views/AlarmPanel')));
const StatisticsPanelManage = Loadable(lazy(() => import('views/StatisticsPanelManage')));
const TextGenerateImage = Loadable(lazy(() => import('views/ExplorationCenter/TextGenerateImage')));
const TextGenerateVoice = Loadable(lazy(() => import('views/ExplorationCenter/TextGenerateVoice')));
const ModelFineTuning = Loadable(lazy(() => import('views/ModelFineTuning_bailian')));
const ModelFineTuningNew = Loadable(lazy(() => import('views/ModelFineTuning')));
const ModelFineService = Loadable(lazy(() => import('views/ModelFineService')));

const ModelFineTuningCreate = Loadable(lazy(() => import('views/ModelFineTuning_bailian/create')));
const ModelFineTuningCreateNew = Loadable(lazy(() => import('views/ModelFineTuning/create')));

const ModelFinetuneDetail = Loadable(lazy(() => import('views/ModelFineTuning_bailian/detail')));
const ModelFinetuneDetailNew = Loadable(lazy(() => import('views/ModelFineTuning/detail')));
const ModelFineServiceCreateNew = Loadable(lazy(() => import('views/ModelFineService/create')));
const ModelFineServiceDetailNew = Loadable(lazy(() => import('views/ModelFineService/detail')));
const TeamManage = Loadable(lazy(() => import('views/TeamManage_new')));
const OrderManageNew = Loadable(lazy(() => import('views/OrderManage_new')));
const UsageStatistics = Loadable(lazy(() => import('views/UsageStatistics')));
const TeamUserToken = Loadable(lazy(() => import('views/TeamManage/UserToken')));
const EnterpriseAuthManage = Loadable(lazy(() => import('views/Identification/EnterpriseAuthManage')));
const CueWordProject = Loadable(lazy(() => import('views/CueWordProject')));
const Agent = Loadable(lazy(() => import('views/Agent')));
const Datasets = Loadable(lazy(() => import('views/Datasets')));
const RoleManage = Loadable(lazy(() => import('views/Permission/RoleManage')));
const PermissionPoint = Loadable(lazy(() => import('views/Permission/PermissionPoint')));
const DataReflux = Loadable(lazy(() => import('views/data-reflux/index')));
const DataRefluxLog = Loadable(lazy(() => import('views/data-reflux/data-reflux-log')));
const LargeScreen = Loadable(lazy(() => import('views/LargeScreen/index')));
const ScreenList = Loadable(lazy(() => import('views/LargeScreen/ScreenList')));
const ModelSpeedLimit = Loadable(lazy(() => import('views/ModelSpeedLimit/index')));
const OtherManagement = Loadable(lazy(() => import('views/System/OtherManagement/index')));
const ThemeManagement = Loadable(lazy(() => import('views/System/ThemeManagement/index')));
const VPNSpecialLineManagement = Loadable(lazy(() => import('views/System/VPNSpecialLineManagement/index')));
const DynamicAnnouncements = Loadable(lazy(() => import('views/AnnouncementsCeter/DynamicAnnouncements/index')));
const UserDashboardCard = Loadable(lazy(() => import('views/AnnouncementsCeter/UserDashboardCard/index')));
const RollingAnnouncements = Loadable(lazy(() => import('views/AnnouncementsCeter/RollingAnnouncements/index')));
const TeamList = Loadable(lazy(() => import('views/TeamList/index')));
const RechargeExchangeRecords = Loadable(lazy(() => import('views/BillingCenter/RechargeExchangeRecords')));
const SensitiveWordManage = Loadable(lazy(() => import('views/SecurityCenter/SensitiveWordManage/index')));
const ContentReviewSetting = Loadable(lazy(() => import('views/SecurityCenter/ContentReviewSetting/index')));
const ContentReviewUserManage = Loadable(lazy(() => import('views/SecurityCenter/ContentReviewUserManage/index')));
const LoginOrRegister = Loadable(lazy(() => import('views/System/UserManagement/LoginOrRegister/index')));
const ConsultativeManagement = Loadable(lazy(() => import('views/System/ConsultativeManagement/index')));
const PersonalAuthentication = Loadable(lazy(() => import('views/AuthenticationCenter/PersonalAuthentication/index')));
const EnterpriseCertification = Loadable(lazy(() => import('views/AuthenticationCenter/EnterpriseCertification/index')));
const EnterpriseOrder = Loadable(lazy(() => import('views/EnterpriseOrder/index')));
const EquityList = Loadable(lazy(() => import('views/EquityManagement/EquityList/index')));
const EquityPoint = Loadable(lazy(() => import('views/EquityManagement/EquityPoint/index')));
const AuthenticationManagement = Loadable(lazy(() => import('views/AuthenticationManagement/index')));
const BillingSettings = Loadable(lazy(() => import('views/BillingSettings/index')));
const DocumentCenter = Loadable(lazy(() => import('views/DocumentCenter/index')));
const InternetSearch = Loadable(lazy(() => import('views/InternetSearch/index')));
const ModelRate = Loadable(lazy(() => import('views/ModelRate/index')));
const EnterprisePlatformEnterpriseInformation = Loadable(lazy(() => import('views/EnterprisePlatform/EnterpriseInformation')));
const EnterprisePlatformTopup = Loadable(lazy(() => import('views/EnterprisePlatform/Topup')));
const EnterprisePlatformOnlineTopup = Loadable(lazy(() => import('views/EnterprisePlatform/OnlineTopup')));
const EnterprisePlatformProfile = Loadable(lazy(() => import('views/EnterprisePlatform/Profile')));
const EnterprisePlatformOrderManage = Loadable(lazy(() => import('views/EnterprisePlatform/OrderManage')));
const EnterprisePlatformOrderConsume = Loadable(lazy(() => import('views/EnterprisePlatform/OrderConsume')));
const EnterprisePlatformTeamManage = Loadable(lazy(() => import('views/EnterprisePlatform/TeamManage')));
const EnterprisePlatformTeamLayout = Loadable(lazy(() => import('views/EnterprisePlatform/TeamManage/component/TeamLayout')));
const EnterprisePlatformTeamMemberList = Loadable(lazy(() => import('views/EnterprisePlatform/TeamManage/TeamMemberList')));
const EnterprisePlatformManageTeam = Loadable(lazy(() => import('views/EnterprisePlatform/TeamManage/ManageTeam')));
const EnterprisePlatformReviewMember = Loadable(lazy(() => import('views/EnterprisePlatform/TeamManage/ReviewMember')));
const EnterprisePlatformAuditTeam = Loadable(lazy(() => import('views/EnterprisePlatform/TeamManage/AuditTeam')));
const EnterprisePlatformVPNPrivateLine = Loadable(lazy(() => import('views/EnterprisePlatform/VPNPrivateLine')));
const EnterprisePlatformToken = Loadable(lazy(() => import('views/EnterprisePlatform/Token_new')));
const EnterprisePlatformPrice = Loadable(lazy(() => import('views/EnterprisePlatform/Price')));
const EnterprisePlatformModelPrice = Loadable(lazy(() => import('views/EnterprisePlatform/EnterPrisePrice')));
const EnterPriseModelActivity = Loadable(lazy(() => import('views/EnterprisePlatform/EnterPriseModelActivity')));
const TeamLayout = Loadable(lazy(() => import('views/TeamManage_new/component/TeamLayout')));
const TeamMemberList = Loadable(lazy(() => import('views/TeamManage_new/TeamMemberList')));
const ManageTeam = Loadable(lazy(() => import('views/TeamManage_new/ManageTeam')));
const ReviewMember = Loadable(lazy(() => import('views/TeamManage_new/ReviewMember')));
const AuditTeam = Loadable(lazy(() => import('views/TeamManage_new/AuditTeam')));

const MainRoutes = {
  path: '/panel',
  element: <HomeLayout />,
  children: [
    {
      path: 'index',
      element: <Dashboard />
    },
    {
      path: 'permission/role/index',
      element: <RoleManage />
    },
    {
      path: 'permission/point/index',
      element: <PermissionPoint />
    },
    {
      path: 'statistics/index',
      element: <StatisticsPanel />
    },
    {
      path: 'alarm/index',
      element: <AlarmPanel />
    },
    {
      path: 'dashboard/index',
      element: <Dashboard />
    },
    {
      path: 'modelsquare/index',
      element: <ModelSquare_new />
    },
    {
      path: 'cuewordproject/index',
      element: <CueWordProject />
    },
    {
      path: 'announcements/center/dynamic/index',
      element: <DynamicAnnouncements />
    },
    {
      path: 'announcements/center/user/dashboard/card/index',
      element: <UserDashboardCard />
    },
    {
      path: 'announcements/center/rolling/index',
      element: <RollingAnnouncements />
    },
    {
      path: 'agent/index',
      element: <Agent />
    },
    {
      path: 'datasets/index',
      element: <Datasets />
    },
    {
      path: 'modelsquaremanage/card/index',
      element: <ModelSquareManage />
    },
    {
      path: 'order/manage_new/index',
      element: <OrderManageNew />
    },
    {
      path: 'modelsquaremanage/modeltag/index',
      element: <ModelTagManage />
    },
    {
      path: 'usage/index',
      element: <UsageStatistics />
    },
    {
      path: 'user_index_distribution/index',
      element: <StatisticsPanelManage />
    },
    {
      path: 'exploration_center/index',
      element: <ExplorationCenterChatBot />
    },
    {
      path: 'exploration_center/text2img/index',
      element: <TextGenerateImage />
    },
    {
      path: 'exploration_center/text2voice/index',
      element: <TextGenerateVoice />
    },
    {
      path: 'modelsquare_new/details/:id',
      element: <ModelDetailsNew />
    },
    {
      path: 'model/fine_tuning',
      element: <ModelFineTuning />
    },
    {
      path: 'model/fine_tuning_pro',
      element: <ModelFineTuningNew />
    },
    {
      path: 'model/fine_tuning/create',
      element: <ModelFineTuningCreate />
    },
    {
      path: 'model/fine_tuning_pro/create',
      element: <ModelFineTuningCreateNew />
    },
    {
      path: 'model/fine_tuning_pro/detail/:id',
      element: <ModelFinetuneDetailNew />
    },
    {
      path: 'model/fine_service',
      element: <ModelFineService />
    },
    {
      path: 'model/fine_service/create/:id',
      element: <ModelFineServiceCreateNew />
    },
    {
      path: 'model/fine_service/detail/:id',
      element: <ModelFineServiceDetailNew />
    },
    {
      path: '/panel/team_usertoken/index',
      element: <TeamUserToken />
    },
    {
      path: '/panel/auth/enterprise/manage/index',
      element: <EnterpriseAuthManage />
    },
    {
      path: '/panel/enterprise_order/index',
      element: <EnterpriseOrder />
    },
    {
      path: 'channel/index',
      element: <Channel />
    },
    {
      path: 'maas/vpn/channel/index',
      element: <MaasVpnChannel />
    },
    {
      path: 'log/index',
      element: <Log />
    },
    {
      path: 'video-task-log/index',
      element: <VideoTaskLog />
    },
    {
      path: 'redemption/index',
      element: <Redemption />
    },
    {
      path: 'setting/index',
      element: <Setting />
    },
    {
      path: 'token/index',
      element: <TokenNew />
    },
    {
      path: 'topup/index',
      element: <Topup />
    },
    {
      path: 'user/index',
      element: <User />
    },
    {
      path: 'profile_new/index',
      element: <ProfileNew />
    },
    {
      path: '404/index',
      element: <NotFoundView />
    },
    {
      path: 'data-reflux/index',
      element: <DataReflux />
    },
    {
      path: 'data-reflux/data-reflux-log',
      element: <DataRefluxLog />
    },
    {
      path: 'large-screen/model/index',
      element: <LargeScreen />
    },
    {
      path: 'large-screen/list/index',
      element: <ScreenList />
    },
    {
      path: 'model-speed-limit/index',
      element: <ModelSpeedLimit />
    },
    {
      path: 'system/other/management/index',
      element: <OtherManagement />
    },
    {
      path: 'system/theme/management/index',
      element: <ThemeManagement />
    }, 
    {
      path: 'system/vpn/special/line/index',
      element: <VPNSpecialLineManagement />
    },
    {
      path: 'team-list/',
      element: <TeamLayout />,
      children: [
        {
          path: 'index',
          element: <TeamList />
        },
        {
          path: 'manage_team',
          element: <ManageTeam />
        },
        {
          path: 'audit_team',
          element: <AuditTeam />
        }
      ]
    },
    {
      path: 'recharge_exchange_records/index',
      element: <RechargeExchangeRecords />
    },
    {
      path: 'sensitive_word_manage/index',
      element: <SensitiveWordManage />
    },
    {
      path: 'content_review_setting/index',
      element: <ContentReviewSetting />
    },
    {
      path: 'content_review_user_manage/index',
      element: <ContentReviewUserManage />
    },
    {
      path: 'user/loginorregister/index',
      element: <LoginOrRegister />
    },
    {
      path: 'consultative/management/index',
      element: <ConsultativeManagement />
    },
    {
      path: '/panel/personal_authentication/index',
      element: <PersonalAuthentication />
    },
    {
      path: '/panel/enterprise_certification/index',
      element: <EnterpriseCertification />
    },
    {
      path: '/panel/equity_list/index',
      element: <EquityList />
    },
    {
      path: '/panel/equity_point/index',
      element: <EquityPoint />
    },
    {
      path: '/panel/authentication/management/index',
      element: <AuthenticationManagement />
    },
    {
      path: '/panel/billing/settings/index',
      element: <BillingSettings />
    },
    {
      path: '/panel/document/center/index',
      element: <DocumentCenter />
    },
    {
      path: '/panel/model/search/endpoint/index',
      element: <InternetSearch />
    },
    {
      path: '/panel/billing/model/rate/index',
      element: <ModelRate />
    },
    {
      path: '/panel/profile/order/manage/index',
      element: <EnterprisePlatformOrderManage />
    },
    {
      path: '/panel/profile/consume/index',
      element: <EnterprisePlatformOrderConsume />
    },
    {
      path: '/panel/profile/index',
      element: <EnterprisePlatformProfile />
    },
    {
      path: '/panel/profile/topup/index',
      element: <EnterprisePlatformTopup />
    },    
    {
      path: '/panel/vpn/private/line/index',
      element: <EnterprisePlatformVPNPrivateLine />
    },    
    {
      path: 'profile/online/topup/index',
      element: <EnterprisePlatformOnlineTopup />
    },
    {
      path: 'my/enterprise/information/index',
      element: <EnterprisePlatformEnterpriseInformation />
    },
    {
      path: '/panel/profile/team_manage',
      element: <EnterprisePlatformTeamLayout />,
      children: [
        {
          path: '',
          element: <EnterprisePlatformTeamManage />
        },
        {
          path: 'team_member_list',
          element: <EnterprisePlatformTeamMemberList />
        },
        {
          path: 'manage_team',
          element: <EnterprisePlatformManageTeam />
        },
        {
          path: 'review_member',
          element: <EnterprisePlatformReviewMember />
        },
        {
          path: 'audit_team',
          element: <EnterprisePlatformAuditTeam />
        }
      ]
    },
    {
      path: '/panel/enterprise/token/index',
      element: <EnterprisePlatformToken />
    },
    {
      path: '/panel/enterprise/price/index',
      element: <EnterprisePlatformPrice />
    },   
    {
      path: '/panel/enterprise/modelPrice/index',
      element: <EnterprisePlatformModelPrice />
    },   
    {
      path: '/panel/enterprise/activity/index',
      element: <EnterPriseModelActivity />
    },   
    
    {
      path: '/panel/team_manage/index',
      element: <TeamManage />
    },
    {
      path: '/panel/team_manage',
      element: <TeamLayout />,
      children: [
        {
          path: 'team_member_list',
          element: <TeamMemberList />
        },
        {
          path: 'manage_team',
          element: <ManageTeam />
        },
        {
          path: 'review_member',
          element: <ReviewMember />
        },
        {
          path: 'audit_team',
          element: <AuditTeam />
        }
      ]
    },
  ]
};

export default MainRoutes;
